// apps/client/src/components/AuthEventListener.tsx

import { useSnackbar } from 'notistack';
import { useEffect } from 'react';

export const AuthEventListener = () => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const handleAuthInvalidated = (event: Event) => {
      enqueueSnackbar('Your session has expired. Please log in again.', {
        variant: 'warning',
      });
    };

    const handleOrganisationChanged = (event: Event) => {
      const { reason, forced } = (event as CustomEvent).detail;

      if (forced) {
        enqueueSnackbar(
          'Your access to the previous organisation was revoked. You have been switched to another organisation.',
          {
            variant: 'warning',
          }
        );
      }
    };

    window.addEventListener('authInvalidated', handleAuthInvalidated);
    window.addEventListener('organisationChanged', handleOrganisationChanged);

    return () => {
      window.removeEventListener('authInvalidated', handleAuthInvalidated);
      window.removeEventListener('organisationChanged', handleOrganisationChanged);
    };
  }, [enqueueSnackbar]);

  return null; // This component doesn't render anything
};
